import { FacetedFilterOption } from "@/components/button-faceted-filter";
import { StaggerItem } from "@/components/company/company-animations";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
import { PlatformIcons } from "./platform-icons";

type NewsStatCardProps = {
  icon: React.ComponentType<{ className?: string }>;
  count: number;
  label: string;
  isLoading: boolean;
  platformOptions: FacetedFilterOption[];
  onClick: (() => void) | undefined;
  customContent?: React.ReactNode;
};

export function NewsStatCard({
  icon: Icon,
  count,
  label,
  isLoading,
  platformOptions,
  onClick,
  customContent,
}: NewsStatCardProps): React.ReactElement {
  return (
    <StaggerItem>
      <Card
        className={cn(
          "h-full transition-all duration-200",
          onClick
            ? "cursor-pointer hover:shadow-lg hover:scale-[1.02]"
            : count === 0 && !customContent && "opacity-50",
        )}
        onClick={onClick}
      >
        <CardContent className="flex flex-col items-center justify-center gap-3 py-8 h-44">
          <div className="shrink-0 rounded-full flex items-center justify-center w-12 h-12 bg-muted">
            <Icon className="w-6 h-6" />
          </div>
          <div className="text-center">
            {/* Nothing counted yet is not "none": no zero while it loads. */}
            {customContent ??
              (isLoading && count === 0 ? (
                <Skeleton className="w-16 h-8 mx-auto" />
              ) : (
                <>
                  <div className="text-3xl font-bold">{count}</div>
                  <div className="text-sm text-muted-foreground">{label}</div>
                </>
              ))}
          </div>
          {!isLoading && platformOptions.length > 0 && (
            <PlatformIcons options={platformOptions} />
          )}
          {isLoading && <Skeleton className="w-20 h-6" />}
        </CardContent>
      </Card>
    </StaggerItem>
  );
}
